@if (categoryToDelete) {
  <p-confirmDialog
    key="categoryDeleteDialog"
    #cd
    styleClass="w-9"
    appendTo="body"
    [blockScroll]="false">
    <ng-template pTemplate="headless" let-message>
      <div class="p-card border-round pt-1 p-4">
        <app-header
          icon="fas fa-trash"
          [text]="categoryToDelete.name + ' wirklich löschen?'"></app-header>

        @if (categoryAndChildren && categoryAndChildren.length) {
          <p appAlertStyle="warning" class="p-3">
            <i class="fas fa-exclamation-triangle"></i>
            Dabei werden auch alle Indikatoren (und die Daten dieser), die mit
            dem Ordner verknüpft sind, unwiderruflich gelöscht!
          </p>
          <p-divider></p-divider>
          <app-header
            icon="fas fa-database"
            text="Enthaltene Bereiche, Indikatoren und Daten"></app-header>
          <p-scrollPanel styleClass="h-20rem">
            @for (category of categoryAndChildren; track category._id) {
              @if (
                this.indicatorStore.getByCategoryId(category._id);
                as categoryIndicators
              ) {
                <p-accordion class="w-full">
                  <p-accordionTab>
                    <ng-template pTemplate="header">
                      <span class="flex align-items-center gap-2">
                        <i class="fas fa-folder"></i> {{ category.name }}
                      </span>
                      <p-badge
                        [value]="categoryIndicators.length"
                        class="ml-auto mr-2" />
                    </ng-template>

                    @for (
                      indicator of categoryIndicators;
                      track indicator._id
                    ) {
                      <h4 class="flex align-items-center gap-2">
                        <i
                          class="fas"
                          [class]="
                            indicator.isSet
                              ? 'fa-ruler-combined'
                              : 'fa-ruler-vertical'
                          "></i>
                        {{ indicator.name }}
                      </h4>
                      <app-indicator-data-list [indicator]="indicator" />
                    }
                  </p-accordionTab>
                </p-accordion>
              } @else {
                <app-alert [canToggle]="false">
                  <div class="flex gap-2 align-items-center">
                    <h4 class="flex align-items-center gap-2">
                      <i class="fas fa-folder"></i> {{ category.name }}:
                    </h4>
                    <i>keine Indikatoren/ Daten enthalten</i>
                  </div>
                </app-alert>
              }
            }
          </p-scrollPanel>
        } @else {
          <app-alert [canToggle]="false" styleClass="p-3">
            <i class="fas fa-circle-info"></i> Diesem Ordner sind keine
            Indikatoren oder Daten zugewiesen.
          </app-alert>
        }

        <p-divider></p-divider>
        <div class="flex align-items-center gap-3 mt-4">
          <button
            [rounded]="true"
            [outlined]="true"
            severity="secondary"
            pButton
            icon="fas fa-times"
            label="nein, abbrechen"
            (click)="cd.reject()"></button>
          <button
            [rounded]="true"
            pButton
            [severity]="'danger'"
            icon="fas fa-check"
            label="ja, löschen"
            (click)="cd.accept()"
            class="ml-auto"></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
}
